export default __webpack_public_path__ + "static/media/data_hall_v1.0cb024af.jpg";